import { ApiType } from "@gymflow/common";
import { downloadCsv, zonedTimeToUtc } from "@gymflow/helpers";
import { useMutation } from "@tanstack/react-query";

export function useMutationLeadListCsv({
  api,
  tz,
}: {
  api: ApiType;
  tz: string;
}) {
  return useMutation({
    mutationFn: async (
      filters?: Parameters<ApiType["leadApi"]["listCsv"]>[0],
    ) => {
      const parsedOpts = { ...filters };
      if (filters?.createdFrom) {
        parsedOpts.createdFrom = zonedTimeToUtc(filters.createdFrom, tz);
      }
      if (filters?.createdTo) {
        parsedOpts.createdTo = zonedTimeToUtc(filters.createdTo, tz);
      }
      return downloadCsv(
        (await api.leadApi.listCsv(parsedOpts)).data,
        "leads.csv",
      );
    },
  });
}
